export default __webpack_public_path__ + "static/media/onshore_wind_icon.8f806997.svg";